<template>
  <div>
    <div class="row">
      <div class="col-12 text-center mb-3">
        <label>Entrega de información base</label>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', cotejo.currentComponentValues.Solicitantes ? 'completado' : '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.Solicitantes" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="selectedComponent === 'Solicitantes' ? 'active-menu' : 'text-menu'" @click="selected('Solicitantes')">
          Solicitante
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', cotejo.currentComponentValues.DomicilioEntregaOriginales ? 'completado' : '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.DomicilioEntregaOriginales" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a
          :class="selectedComponent === 'DomicilioEntregaOriginales' ? 'active-menu' : 'text-menu'"
          @click="selected('DomicilioEntregaOriginales')"
        >
          Lugar de Entrega
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', cotejo.currentComponentValues.Documentos ? 'completado' : '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.Documentos" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="selectedComponent === 'Documentos' ? 'active-menu' : 'text-menu'" @click="selected('Documentos')">
          Documentos
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', cotejo.currentComponentValues.Cotizacion ? 'completado' : '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.Cotizacion" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="selectedComponent === 'Cotizacion' ? 'active-menu' : 'text-menu'" @click="selected('Cotizacion')">
          Cotización
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', cotejo.currentComponentValues.Pago ? 'completado' : '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.Pago" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="selectedComponent === 'Pago' ? 'active-menu' : 'text-menu'">Pago</a>
      </div>
    </div>

    <div class="row">
      <div class="col-12 text-center mb-3">
        <label>Complementa la información</label>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer" v-if="cotejo.envio_domicilio">
      <div class="ml-3">
        <div :class="['circle', cotejo.currentComponentValues.Domicilio ? 'completado' : '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.Domicilio" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a :class="selectedComponent === 'Domicilio' ? 'active-menu' : 'text-menu'" @click="selected('Domicilio')">
          Domicilio de Entrega
        </a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', '']">
          <span class="number">
            <i v-if="cotejo.currentComponentValues.Solicitantes == 1" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a class="text-menu">Solicitante</a>
      </div>
    </div>

    <div class="row flex align-items-center p-2 pointer">
      <div class="ml-3">
        <div :class="['circle', '']">
          <span class="number">
            <i v-if="cotejo.id_estatus >= 16 && cotejo.id_estatus !== 44" class="fa fa-check"></i>
            <i v-else class="fa fa-minus"></i>
          </span>
        </div>
      </div>
      <div class="ml-3">
        <a class="text-menu">Documentos</a>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "TreeCotejo",

  props: {
    cotejo: { type: Object },
    user: { type: String },
    selectedComponent: { type: String },
  },

  methods: {
    selected(node) {
      this.$emit("node", node);
    },
  },
};
</script>

<style scoped>
.number {
  font-size: 11px;
  color: white;
}
</style>
